import {isLarge} from "./helpers";
require('bootstrap/js/scrollspy');

(function ($) {

  "use strict";

  $(document).ready(function () {
    backToTopLink();
    animateScrollTo();
    longFormDoc();
  });
})(jQuery);

function trimLeadingTrailingSlashes(path) {
  return path.replace(/^\//, "").replace(/\/$/, "");
}

/**
 * Overrides default browser behaviour when navigating to a hash on the current page.
 * Animates the scroll to the target element.
 *
 * Applies site-wide, and one of the primary uses is on LongFormDocument pages for jumping between
 * sections via the sticky 'Index' sidebar
 *
 * See also:
 * `accordions.js` for animating scroll to an accordion on page load via URL hash
 */
function animateScrollTo() {
  $("#main-page-content").on("click", "a[href*='#']", function (e) {
    let target;
    const $linkElement = $(this);
    const linkHash = $linkElement.prop("hash");
    // Height (px) of sticky header in it's small state
    const headerHeight = 66;

    const linkPathName = trimLeadingTrailingSlashes($(this).prop("pathname")) || "";
    const currentPathName = trimLeadingTrailingSlashes(location.pathname);

    const hasHash = !!linkHash;
    const isCurrentPath = linkPathName === "" ||  linkPathName === currentPathName;
    const isCurrentHostname = $(this).prop("hostname") === location.hostname;

    /**
     * Check if the link targets a hash on the current page, for example:
     *   <a href='#section-two`></a>
     *   <a href='current/page/path#section-two'></a>
     */
    if (isCurrentHostname && isCurrentPath && hasHash) {
      e.preventDefault();
      // Look for an element with a matching ID
      target = $(linkHash);

      if (!target.length) {
        // Check for accordion landmarks using the `name` attribute - See `ElementAccordion.ss`
        target = $("[name='" + linkHash.slice(1) + "']");
      }
    }

    if (!(target && target.length)) {
      return;
    }

    // If the target is within an accordion, make sure it's open
    if ($(target).closest(".accordion").length) {
      accordion.openAccordion($(target).closest(".accordion"));
    }

    target.attr("tabindex", "-1");
    const scrollDepth = target.offset().top - headerHeight - 20;
    $("html, body").animate({ scrollTop: scrollDepth }, 600, function () {
      target.focus();
      // Temporarily remove ID attribute from the target to prevent browser jumping to it
      const targetId = target.attr("id");
      target.attr("id", "");

      // Update the URL with the new hash
      if (history.pushState) {
        history.pushState(
          { clickedScroll: true },
          null,
          location.origin + location.pathname + linkHash
        );
      } else {
        window.location.hash = linkHash;
      }

      // Reinstate target ID attribute
      target.attr("id", targetId);
    });

    return false;
  });
}

export function stickyBackToTop(scrollOffset, screenHeight, footerOffset) {
  if (scrollOffset > screenHeight) {
    $("#back-to-top .back-to-top__button").fadeIn(200);
  } else {
    $("#back-to-top .back-to-top__button").fadeOut(200);
  }

  if (scrollOffset + screenHeight >= footerOffset) {
    $("#back-to-top").css({
      position: "absolute",
      bottom: "0",
    });
  } else {
    $("#back-to-top").css({
      position: "",
      bottom: "",
    });
  }
}

function backToTopLink() {
  $("#back-to-top .back-to-top__button").on("click", function (e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );

    $("#main-page-content").focus();
  });
}

function longFormDoc() {
  // enable scrollspy
  if ($("#lf-doc-nav").length > 0) {
    $("body").scrollspy({
      target: "#lf-doc-nav",
      offset: 88,
    });
  }

  // hide lower section nav
  $("#lf-doc-nav > ul > li > ul").css("height", 0).hide();

  // toggle lower section nav when scrollspy section active
  $("#lf-doc-nav").on("activate.bs.scrollspy", function () {
    $("#lf-doc-nav li").each(function () {
      var linkItem = $(this);
      var subTier = linkItem.children("ul");

      if (linkItem.hasClass("active")) {
        if (isLarge() && subTier.length > 0) {
          subTier
            .stop()
            .show()
            .animate(
              {
                height: subTier.prop("scrollHeight"),
              },
              100,
              function () {}
            );
        }
      } else {
        if (subTier.length > 0) {
          subTier.stop().animate(
            {
              height: 0,
            },
            100,
            function () {
              subTier.hide();
            }
          );
        }
      }
    });
  });

  // set width of nav to outer container inner width for fixed scrolling on desktop
  sizeLFDocNav();

  // tablet / mobile accordion of scrolling nav
  toggleLFDocNavInit();

  // resize behaviour for long form document elements
  var resizeTimer;

  $(window).on("resize.lfdoc", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      sizeLFDocNav();
      toggleLFDocNavInit();
    }, 100);
  });
}

function sizeLFDocNav() {
  if (isLarge()) {
    $("#lf-doc-nav").css("width", $(".lf-nav-wrapper").width());
  } else {
    $("#lf-doc-nav").css("width", "");
  }
}

function toggleLFDocNavInit() {
  var headingLFDoc = $("#lf-doc-nav > h2");

  if (!isLarge()) {
    // enable section nav toggle
    if (!headingLFDoc.children("button").length > 0) {
      headingLFDoc.wrapInner(
        '<button class="button button--primary lf-doc-nav__toggle" aria-controls="lf-doc-nav-list" aria-expanded="false" title="Toggle section navigation open or closed"></button>'
      );

      headingLFDoc.children("button").on("click", function (e) {
        if (headingLFDoc.hasClass("open")) {
          closeLFDocNav(headingLFDoc);
        } else {
          openLFDocNav(headingLFDoc);
        }
      });
    }

    closeLFDocNav(headingLFDoc);
  } else {
    // disable / remove section nav toggle
    headingLFDoc.removeClass("open").next("ul.nav").show();
    $("#lf-doc-nav ul.nav > li > a").off(".openNav");
    headingLFDoc.children("button").off("click");
    headingLFDoc
      .children("button")
      .attr("aria-expanded", "true")
      .contents()
      .unwrap();
  }
}

function openLFDocNav(headingLFDoc) {
  headingLFDoc.next("ul.nav").show();
  headingLFDoc.addClass("open");
  headingLFDoc.children("button").attr("aria-expanded", "true");

  $("#lf-doc-nav .lf-nav__link").on("click.openNav", function (e) {
    closeLFDocNav(headingLFDoc);
  });
}

function closeLFDocNav(headingLFDoc) {
  headingLFDoc.next("ul.nav").hide();
  headingLFDoc.removeClass("open");
  headingLFDoc.children("button").attr("aria-expanded", "false");

  $("#lf-doc-nav .lf-nav__link").off(".openNav");
}

export function stickyLFDocNav(
  scrollOffset,
  screenHeight,
  longFormDocContentOffset,
  pageHeadHeight,
  footerOffset,
  longFormIndexHeight,
  longFormDocHeadHeight
) {
  if (isLarge()) {
    // reset css styles (from tablet)
    $("#lf-doc-nav").show();
    $("#lf-doc-nav > ul.nav").css({
      "max-height": "",
    });

    var $navContainer = $("#lf-doc-nav").parent();

    if (!$navContainer.length) {
      return;
    }

    var bottomOfNavContainer =
      $navContainer.outerHeight() + $navContainer.offset().top;

    // set css for scroll position
    if (
      scrollOffset >= longFormDocContentOffset - pageHeadHeight - 20 &&
      scrollOffset <
        bottomOfNavContainer - (pageHeadHeight + 20 + longFormIndexHeight)
    ) {
      // scrolling mid-way in page
      $("#lf-doc-nav").css({
        position: "fixed",
        top: pageHeadHeight + 20,
        bottom: "",
        "max-height": screenHeight - pageHeadHeight - 40,
      });
    } else if (
      scrollOffset >=
      bottomOfNavContainer - (pageHeadHeight + 20 + longFormIndexHeight)
    ) {
      // scrolled to bottom
      $("#lf-doc-nav").css({
        position: "absolute",
        top: "unset",
        bottom: "0",
        "max-height": screenHeight - pageHeadHeight - 40,
      });
    } else {
      // at or near top of page
      $("#lf-doc-nav").css({
        position: "",
        top: 0,
        bottom: "",
        "max-height": "",
      });
    }
  } else {
    // prevent max-height on outer container (from desktop)
    $("#lf-doc-nav").css({
      "max-height": "",
      top: "",
    });

    // set css for scroll position
    if (scrollOffset >= longFormDocContentOffset - pageHeadHeight) {
      // scrolling mid-way in page
      $("#lf-doc-nav").show();
      $("#lf-doc-nav > ul.nav").css({
        "max-height": screenHeight - pageHeadHeight - longFormDocHeadHeight,
      });
    } else {
      // at or near top of page
      $("#lf-doc-nav").hide();
      $("#lf-doc-nav > ul.nav").css({
        "max-height": "",
      });
    }
  }
}
